import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
} from '../../components'

const Styles = require('./TargetDateSeriesMethodologyLink.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesMethodologyLink extends Component {
  static propTypes = {
    // three letters, fff/dff/gef/gff/pff/wff/tff
    iyvCode: PropTypes.string.isRequired,
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
    // the type of link, methodology/fullProfile
    linkType: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props)
    this.state = this.getMethodologyLinkState(
      props.iyvCode,
      props.targetDateSeries,
    )
  }

  componentWillReceiveProps(props){
    this.setState(
      this.getMethodologyLinkState(
        props.iyvCode,
        props.targetDateSeries
      )
    )
  }

  getMethodologyLinkState(iyvCode, targetDateSeries){
    const { ticker, fund_legal_name, fund_id,
        investment_vehicle_id } = targetDateSeries

    const sTicker = ticker || 'N'

    const urlBuilder = (route, profilePath) => {
      return route + '/fund/' +
        format.sanitize(fund_legal_name) + '/' +
        sTicker + '/' +
        profilePath + '/' +
        fund_id + '/' +
        investment_vehicle_id
    }

    let fullProfileUrl = null
    let fullProfileText = null
    let methodologyUrl = null
    switch (iyvCode) {
      case 'fff':
        fullProfileUrl = urlBuilder(
          config.links.fff,
          'fossil-fuel-investments'
        )
        fullProfileText = 'Fossil Free Funds'
        methodologyUrl = config.routes.companies + '#fossilfuels'
        break

      case 'dff':
        methodologyUrl = config.routes.companies + '#deforestation'
        fullProfileUrl = urlBuilder(
          config.links.dff,
          'profile'
        )
        fullProfileText = 'Deforestation Free Funds'
        break

      case 'ffb':
        methodologyUrl = config.routes.companies + '#fossilfinance'
        fullProfileUrl = urlBuilder(
          config.links.fff,
          'fossil-finance-insurance'
        )
        fullProfileText = 'Fossil Free Funds'
        break

      case 'ffi':
        methodologyUrl = config.routes.companies + '#fossilinsurance'
        fullProfileUrl = urlBuilder(
          config.links.fff,
          'fossil-finance-insurance'
        )
        fullProfileText = 'Fossil Free Funds'
        break

      case 'gef':
        // methodologyUrl = config.routes.companies + '#genderequality'
        fullProfileUrl = urlBuilder(
          config.links.gef,
          'gender-lens-score'
        )
        fullProfileText = 'Gender Equality Funds'
        break

      case 'gff':
        methodologyUrl = config.routes.companies + '#civilianfirearms'
        fullProfileUrl = urlBuilder(
          config.links.gff,
          'gun-investments'
        )
        fullProfileText = 'Gun Free Funds'
        break

      case 'pff':
        methodologyUrl = config.routes.companies + '#prisonindustrialcomplex'
        fullProfileUrl = urlBuilder(
          config.links.pff,
          'prison-industrial-complex-investments'
        )
        fullProfileText = 'Prison Free Funds'
        break

      case 'wff':
        methodologyUrl = config.routes.companies + '#militaryweapons'
        fullProfileUrl = urlBuilder(
          config.links.wff,
          'weapon-investments'
        )
        fullProfileText = 'Weapon Free Funds'
        break

      case 'tff':
        methodologyUrl = config.routes.companies + '#tobacco'
        fullProfileUrl = urlBuilder(
          config.links.tff,
          'tobacco-profile'
        )
        fullProfileText = 'Tobacco Free Funds'
        break
    }

    return {
      methodologyUrl,
      fullProfileUrl,
      fullProfileText
    }
  }

  render() {
    const { methodologyUrl, fullProfileUrl, fullProfileText } = this.state
    if (!fullProfileUrl || !fullProfileText) {
      return null
    }

    return (
      <div>
        {
          this.props.linkType === 'methodology' && methodologyUrl ?
            (
              <div styleName='companies-methodology-link'>
                <span>Methodology</span>
                <div>
                  <Link
                    to={methodologyUrl}
                    title='Methodology: How were these companies identified?'
                    xstrong
                  >
                    How were these companies identified?
                  </Link>
                </div>
              </div>
            ) :
            null
        }
        {
          this.props.linkType === 'fullProfile' && fullProfileUrl ?
            (
              <div styleName='companies-methodology-link'>
                <span>Full results</span>
                <div>
                  <Link
                    to={fullProfileUrl}
                    title={fullProfileText}
                    xstrong
                  >
                    See full results for this fund at {fullProfileText}
                  </Link>
                </div>
              </div>
            ) :
            null
        }
      </div>
    )
  }
}